'use client';

import { Dialog, DialogContent } from '@/components/ui/dialog';

import { cn } from '@/lib/utils';

interface BaseOnboardingModalProps {
	open: boolean;
	children: React.ReactNode;
	className?: string;
	transparent?: boolean;
	onClose?: () => void;
}

export function BaseOnboardingModal({
	open,
	children,
	className = 'max-w-[95vw] [&>*]:min-w-0 sm:max-w-[500px]',
	transparent = false,
	onClose,
}: BaseOnboardingModalProps) {
	return (
		<Dialog
			open={open}
			modal={true}
		>
			<DialogContent
				overlayProps={{
					className: 'opacity-100 backdrop-blur-sm bg-primary/50',
				}}
				className={cn(
					transparent ? 'border-none bg-transparent p-0 shadow-none ' + className : className
				)}
				onInteractOutside={(e) => e.preventDefault()}
				onEscapeKeyDown={(e) => {
					e.preventDefault();
					onClose?.();
				}}
			>
				{children}
			</DialogContent>
		</Dialog>
	);
}
